<template>
    <div class="services-sms-details">

        <!-- Titulo da página -->
        <mu-title color="secondary" textStrong="700">Detalhes da campanha</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <br>

        <div v-if="!loading">
            <!-- Detalhes da campanha -->
            <mu-paper :z-depth="1">

                <div class="details">
                    <div>
                        <span class="origin" v-bind:class="{ 'app': campaign.origin === 'app' || campaign.origin === 'app#', 'api': campaign.origin === 'single' || campaign.origin === 'v2' || campaign.origin === 'v1' }">{{ campaign.origin === 'v1' || campaign.origin === 'v2' || campaign.origin === 'single' ? 'API' : 'WEB ' + campaign.origin.replace('app', '') }}</span>
                        <span class="origin type" v-if="campaign.services.type === 'voice'">Mensagem de Voz</span>
                    </div>

                    <!-- Data e titulo da campanha -->
                    <div class="date" v-bind:class="{ 'schedule': isSchedule, 'deleted': isDeleted }">
                        <font-awesome-icon icon="calendar-alt"/> {{ textDate() }}
                    </div>

                    <mu-title color="secondary" type="h1" textStrong="900">{{ campaign.title }}</mu-title>

                    <!-- Mensagem/texto da campanha -->
                    <div class="message">
                        <strong><u>Mensagem:</u></strong>
                        <div class="break-line">
                            {{ campaign.message }}
                        </div>
                    </div>

                    <div v-if="countChars(campaign.message) > 160" class="alert-limit-characters">
                        <font-awesome-icon icon="exclamation-triangle" /> A mensagem contém {{ countChars(campaign.message) }} caracteres. {{ countCredits(campaign.message) }} créditos serão consumidos para cada contato.
                    </div>

                    <div class="user-cost">
                        <div v-if="campaign.cost" class="center-cost">
                            <font-awesome-icon icon="funnel-dollar" class="icon-md icon-margin-left"/> Centro de Custo <strong>{{ campaign.cost.name }}</strong>
                        </div>

                        <div class="user" v-if="campaign.users">
                            <font-awesome-icon icon="user-friends" class="icon-md icon-margin-left"/> <span class="text"> Criado por <strong>{{ campaign.users ? campaign.users.fullName : '' }}</strong></span>
                        </div>
                        <div class="user" v-else>
                            <div v-if="campaign.origin == 'v2' || campaign.origin == 'v1' || campaign.origin == 'single'">
                                <font-awesome-icon icon="code" class="icon-md icon-margin-left"/> <span class="text"> Criado pela <strong>API</strong></span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Estatísticas -->
                <mu-campaign-statistics :id="campaign.id"></mu-campaign-statistics>

            </mu-paper>

            <!-- Lista de contatos -->
            <div class="contacts" v-if="!contacts.loading">
                <mu-paper :z-depth="1">

                    <!-- Título e botão para download -->
                    <mu-row justify-content="center" align-items="center">
                        <mu-col span="6" sm="6" md="6" lg="6" xl="6">
                            <mu-title type="h2" color="secondary" textStrong="600">Lista de envios</mu-title>
                        </mu-col>
                        <mu-col span="6" sm="6" md="6" lg="6" xl="6" class="btn-download">
                        </mu-col>
                    </mu-row>

                    <mu-divider></mu-divider>

                    <!-- Listagem dos contatos tablet/desktop -->
                    <mu-data-table :columns="contacts.columns" no-data-text="Nenhum contato na campanha" :data="contacts.list" v-if="viewport !== 'mobile'" class="mu-table-custom">
                        <template slot-scope="scope">
                            <td><span v-if="scope.row.sended_at">{{ dateFormat(scope.row.sended_at, true) }}</span></td>
                            <td>{{ scope.row.name }}</td>
                            <td>{{ scope.row.phone }}</td>
                            <td><div class="message">{{ scope.row.message }}</div></td>
                            <td><mu-dot :color="scope.row.status_color"></mu-dot> {{ scope.row.status }}</td>
                        </template>
                    </mu-data-table>

                    <!-- Listagem de contatos mobile -->
                    <div textline="three-line" v-if="viewport === 'mobile'">
                        <div class="item-mobile" v-for="(item, key) in contacts.list" :key="key">
                            <h4>{{ item.phone }}</h4>
                            {{ item.name }} <br v-if="item.name">
                            <span v-if="item.sended_at">{{ dateFormat(item.sended_at, true) }}</span> <br v-if="item.sended_at">
                            <mu-dot :color="item.status_color"></mu-dot> {{ item.status }}
                        </div>
                    </div>

                </mu-paper>

                <!-- Paginação -->
                <mu-flex class="paginate" justify-content="center" v-if="contacts.paging.total > 10">
                    <mu-pagination :total="contacts.paging.total" :page-count="5" :current.sync="contacts.paging.page" @change="loadSends()"></mu-pagination>
                </mu-flex>
            </div>

            <!-- Loading -->
            <mu-loading text="Aguarde, carregando os contatos" v-if="contacts.loading"></mu-loading>

            <!-- Bloco para cancelar campanha -->
            <mu-paper class="cancel" :z-depth="1" v-if="!wasSent() && campaign.deleted_at === null">

                <!-- Pergunta para cancelar campanha  -->
                <mu-row class="user-cost" justify-content="center" align-items="center">
                    <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                        <mu-flex class="title" justify-content="start" align-items="center">
                            <font-awesome-icon icon="exclamation-triangle" class="icon-md color-red"/>
                            <strong>Cancelar campanha</strong>
                        </mu-flex>
                        Todos os dados desta campanha serão perdidos e não terá como voltar.
                    </mu-col>
                    <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                        <div class="text-right">
                            <mu-button round color="error" @click="handleAlertDialog(true)">
                                <font-awesome-icon icon="trash" class="icon-md icon-margin-left"/>
                                Cancelar
                            </mu-button>
                        </div>
                    </mu-col>
                </mu-row>

                <!-- Dialogo para confirmar exclusão de campanha -->
                <mu-dialog title="Cancelar campanha" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="cancel.openAlert">
                    O nome da campanha a ser cancelado é <strong>{{ campaign.title }}</strong>
                    <mu-button slot="actions" round @click="handleAlertDialog(false)">Cancelar</mu-button>
                    <mu-button slot="actions" round color="error" @click="deleteForm()">
                        <font-awesome-icon icon="check" class="icon-sm icon-margin-left"/>
                        Confirmar
                    </mu-button>
                </mu-dialog>

            </mu-paper>
        </div>

        <!-- Loading -->
        <mu-loading text="Carregando os dados da campanha" v-if="loading"></mu-loading>

    </div>
</template>

<script>
    import moment from 'moment'
    import momentTimezone from 'moment-timezone'
    import CampaignsServices from '@/services/services/sms'
    import MessagesServices from '@/services/services/messages'

    export default {
        name: 'services-sms-details',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                loading: false,
                campaign: {},
                contacts: {
                    loading: false,
                    paging: {
                        page: 1,
                        total: 0
                    },
                    columns: [
                        { title: 'Data Envio', name: 'data' },
                        { title: 'Nome', name: 'name' },
                        { title: 'Número', name: 'phone' },
                        { title: 'Mensagem', name: 'message' },
                        { title: 'Status', name: 'status' }
                    ],
                    list: []
                },
                cancel: {
                    openAlert: false
                },
                statistics: {
                    loading: false
                },
                isSchedule: false,
                isDeleted: false,
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Campanhas',
                        route: 'app.services.sms',
                        disabled: false
                    },
                    {
                        text: 'Detalhes da campanha',
                        disabled: true
                    }
                ]
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Chamamos o load() e loadSends() assim que o componente for criado
         */
        async created () {
            await this.load()
            await this.loadSends()
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            // Utilizado para verificar se o acesso é de desktop, table ou mobile
            viewport () {
                return this.$currentViewport.label
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Mètodo responsável por abrir e fechar o dialogo permitindo o cancelamento da campanha
             */
            handleAlertDialog (value) {
                this.cancel.openAlert = value
            },

            /**
             * Carrega os dados campanha
             */
            async load () {
                try {
                    this.loading = true

                    let result = await CampaignsServices.find(this.$route.params.id)

                    if (result && result.status) {
                        this.campaign = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.loading = false
                }
            },

            /**
             * Carrega a listagem de envios da campanha, passado
             * a paginação como parâmetro
             */
            async loadSends () {
                this.contacts.loading = true

                let result = await MessagesServices.findAll(this.$route.params.id, {
                    page: this.contacts.paging.page
                })

                if (result && result.status) {
                    this.contacts.paging.page = result.currentPage
                    this.contacts.paging.total = result.rowCount
                    this.contacts.list = result.results
                } else {
                    this.$eventHub.$emit('snackbar', 'error', result.message, false)
                }

                this.contacts.loading = false
            },

            /**
             * Método responsável por cancelar a campanha
             */
            async deleteForm () {
                try {
                    if (this.wasSent()) {
                        this.$eventHub.$emit('snackbar', 'error', 'Esta campanha não pode ser mais cancelada.', false)
                        return
                    }

                    this.$eventHub.$emit('loading', true, 'Aguarde... Cancelando a campanha...')

                    let result = await CampaignsServices.destroy(this.$route.params.id)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.services.sms' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Verificando a data da campanha, para trazer o termo correto se já foi
             * enviada ou esta como agendada
             */
            textDate () {
                if (this.campaign.deleted_at !== null) {
                    this.isDeleted = true
                    return `Campanha cancelada em ${moment(this.campaign.deleted_at).format('DD/MM/YYYY HH:mm')}`
                }

                if (this.campaign.sented_at === null && this.campaign.scheluded_to === null) {
                    return ''
                }

                if (this.wasSent()) {
                    if (this.campaign.sented_at) {
                        return `Enviado em ${momentTimezone.utc(this.campaign.sented_at).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm')}`
                    }
                }

                this.isSchedule = true
                return `Agendado em ${moment(this.campaign.scheluded_to || this.campaign.sented_at).format('DD/MM/YYYY HH:mm')}`
            },

            /**
             * Método verifica se a campanha já foi enviada
             */
            wasSent () {
                let schedule
                let now = moment().format('YYYY-MM-DD HH:mm')
                let sented = momentTimezone.utc(this.campaign.sented_at).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm')
                if (this.campaign.scheluded_to) {
                    schedule = moment(this.campaign.scheluded_to).format('YYYY-MM-DD HH:mm')
                }
                if (this.campaign.scheluded_to) {
                    if (schedule <= now) {
                        return true // já foi enviado
                    }
                    return false // não foi enviado
                }
                if (sented <= now) {
                    return true // já foi enviado
                }
                return false // não foi enviado
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../../assets/stylus/bootstrap.styl'

    .details
        padding 0 10px 10px 10px
        color #333

        .origin
            background $color-gray
            padding 2px 7px
            color #ffffff
            font-size 10px
            text-transform uppercase
            &.app
                background $primary
            &.api
                background $secondary
            &.type
                background $orange
                margin-left 5px

        .date
            padding-top 10px
            font-size 11px
            color #777
            &.schedule
                color $schedule

        .mu-title
            margin 8px 0
            font-size 24px

        .statistics
            padding 20px 0
            color #777
            .text-right
                text-align right

            &.mu-loading
                text-align center
                .text
                    padding-left 10px
                    font-size 12px

        .user-cost
            margin 10px 0
            font-size 12px
            line-height 24px

            svg
                width 14px
                font-size 12px

        .message
            font-size 12px
            padding-bottom 10px

            .break-line
                white-space pre-line

        .alert-limit-characters
            font-size 11px
            color darken($red, 10%)

    .contacts
        margin 20px 0

        .mu-list
            padding 0

        .mu-title
            margin 0

        .row
            margin 0 20px
            padding 15px 0

            .btn-download
                text-align right
                span
                    display none

        .paginate
            padding 20px

        .mu-paper
            padding 0px

        .message
            white-space pre-line

        .item-mobile
            padding 10px
            font-size 11px
            h4
                font-size 14px
                color $primary
                margin 0

    .cancel
        background lighten(#F44336, 92%)
        padding 20px
        color #999
        border 1px #F44336 dotted

        .title
            i
                font-size 18px !important
                color #F44336
            strong
                font-size 16px
                padding-left 5px
                color #F44336

        .text-center
            text-align center

        .text-right
            text-align right

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .details
            padding 0 20px 10px 20px
            color #333

            .color-red
                color #f44336

</style>
